





























import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';

import Node from '@/models/Node';
import Mutations from '@/store/mutations';
import { SendPacket } from '@/networking/SendPacket';
import ProjectServer from '@/models/ProjectServer';
import { PacketType } from '@/models/Packet';
import KeyListener from '@/KeyListener';

@Component({})
export default class Quicksearch extends Vue
{
    @Prop() readonly nodes? : Node[];

    input : string = '';
    opacity : number = 0;

    mounted()
    {
        this.opacity = 0;
        setTimeout(() =>
        {
            this.opacity = 1;
        }, 10);
    }

    get nodesToSearch() : Node[]
    {
        return (this.nodes || this.$store.getters.nodes.values());
    }

    onSubmit(ev : Event)
    {
        ev.preventDefault();
        let exactMatchFound = false;
        let bestPartialMatch : Node | null = null;
        let bestPartialMatchPosition : number = Number.MAX_VALUE;
        let bestCompleteMatch : Node | null = null;
        let bestCompleteMatchPosition : number = Number.MAX_VALUE;
        let bestCompleteMatchLength : number = Number.MIN_VALUE;
        for (let n of this.nodesToSearch)
        {
            let test = this.input.toLowerCase();
            let name = n.name.toLowerCase();
            if (name === test) // exact match found
            {
                this.setSelectedNode(n);
                exactMatchFound = true;
                break; // can stop searching
            }
            else 
            {
                /*
                // complete match check
                let completeMatchPosition = test.indexOf(name);
                if (completeMatchPosition >= 0)
                {
                    // settle ties by length of match
                    if (completeMatchPosition < bestCompleteMatchPosition
                        || (completeMatchPosition === bestCompleteMatchPosition && name.length > bestCompleteMatchLength))
                    {
                        bestCompleteMatch = n;
                        bestCompleteMatchPosition = completeMatchPosition;
                        bestCompleteMatchLength = name.length;
                    }
                }
                else 
                {
                */
                    // partial match check
                    let partialMatchPosition = name.indexOf(test);
                    if (partialMatchPosition >= 0 && partialMatchPosition < bestPartialMatchPosition)
                    {
                        bestPartialMatch = n;
                        bestPartialMatchPosition = partialMatchPosition;
                    }
                /*
                }
                */
            }
        }
        if (!exactMatchFound)
        {
            /*
            if (bestCompleteMatch != null)
            {
                this.setSelectedNode(bestCompleteMatch);
                this.$emit('close');
            }
            else 
            */
            if (bestPartialMatch != null)
            {
                this.setSelectedNode(bestPartialMatch);
                this.$emit('close');
            }
            else if (this.input.length <= 50 && this.input.length > 1)
            {
                this.input = this.input.substring(0, this.input.length - 1);
                this.onSubmit(ev);
            }
            else
            {
                this.$bvToast.toast(`No match found!`, 
                {
                    title: 'Quicksearch Failed',
                    autoHideDelay: 5000
                });
            }
        }
        else
        {
            this.$emit('close');
        }
    }

    onReset(ev : Event)
    {
        ev.preventDefault();
        this.input = '';
        this.$emit('close');
    }

    setSelectedNode(n : Node)
    {
        if (this.$store.state.project.selected !== n)
        {
            this.$store.commit(Mutations.setSelected, n);
        }
    }
}
